module.exports = __webpack_public_path__ + "static/media/fernanda_eucene_logotipo_rosa.ea48b9fc.png";